import { BridgeComponent, Message } from '@hotwired/hotwire-native-bridge';

interface HealthConnectCheckResponseData {
  status: string;
}

interface HealthConnectCheckResponseMessage extends Message {
  data: HealthConnectCheckResponseData;
}

export default class HealthConnectController extends BridgeComponent {
  public static component = 'health-connect';

  public connect(): void {
    this.send(
      'check',
      {},
      ({ data: { status } }: HealthConnectCheckResponseMessage) => {
        document.dispatchEvent(
          new Event(`virtualtrails.health_connect_authorization_${status}`)
        );
      }
    );
  }

  public authorize(e: Event): void {
    if (e.target && 'disabled' in e.target) {
      e.target.disabled = true;
    }

    this.send('authorize');
  }

  public hide(): void {
    this.element.classList.add('d-none');
  }

  public show(): void {
    this.element.classList.remove('d-none');
  }
}
